import { render, staticRenderFns } from "./registerForm.vue?vue&type=template&id=ccaf9624&"
import script from "./registerForm.vue?vue&type=script&lang=js&"
export * from "./registerForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports